import React, { useEffect, useState } from 'react'
import { ItemTabVM } from '../../../Structure/ViewModels/Admin/ItemTabVM'

const ItemTab = (props:{id:string , value:string , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة', index:number , selected:boolean , onSelect:(id:string)=>void , onDelete:(id:string)=>void}) => {
    const [vm , setVm] = useState<{viewModel:ItemTabVM}>({viewModel: new ItemTabVM(props.id , props.value , props.dataType)})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm),[])
    
  return (
    <div>{
    control.Show(
    control.Deleting?(
      <div className='w-100 py-3 d-flex justify-content-center flex-wrap' style={{background:'rgba(240,240,240,1)'}}>
          <div className='d-flex justify-content-center'>
              هل تريد حذف {props.dataType} ؟
          </div>
          <div className={`material-symbols-outlined px-3 text-success c-pointer`} onClick={()=>{control.delete( props.onDelete);}}>
              check
          </div>
          <div className='material-symbols-outlined px-3 text-danger c-pointer' onClick={()=>control.Deleting = false}>
              close
          </div>
      </div>
    ):(
    <div
        className={`p-2 d-flex justify-content-between c-pointer py-3 ${props.selected?' bg-I text-white ':''} `} 
        style={{background:props.selected?(''):(props.index%2?'rgba(250,250,250,0.5)':'rgba(240,240,240,1)')}} 
        
        >

        <div className='w-100' onClick={()=>{props.onSelect(control.Id) }}>{control.Value}</div>
        <div className={`material-symbols-outlined ${props.selected?'danger-item-selected':'danger-item'} c-pointer`} onClick={()=>control.Deleting = true}  > delete  </div>
    </div>))}</div>
  )
}

export default ItemTab
